"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.surveyItem = void 0;
const plugin_html_multi_response_1 = __importDefault(require("@jspsych-contrib/plugin-html-multi-response"));
const taskStore_1 = require("../../../taskStore");
const helpers_1 = require("../../shared/helpers");
const __1 = require("../../..");
const taskSetup_1 = require("../../taskSetup");
const updateProgressBar_1 = require("../../shared/helpers/updateProgressBar");
const staggerButtons_1 = require("../../shared/helpers/staggerButtons");
const replayButtonHtmlId = 'replay-btn-revisited';
let startTime;
let selectedButtonIndex;
const surveyItem = ({ responseAllowed, promptAboveButtons, task, layoutConfigMap, }) => {
    return {
        type: plugin_html_multi_response_1.default,
        data: () => {
            const stim = (0, taskStore_1.taskStore)().nextStimulus;
            return {
                save_trial: true,
                assessment_stage: stim.assessmentStage,
                isPracticeTrial: false,
            };
        },
        stimulus: () => {
            const stim = (0, taskStore_1.taskStore)().nextStimulus;
            const t = (0, taskStore_1.taskStore)().translations;
            const prompt = stim.audioFile;
            return `<div class="lev-stimulus-container">
        <div class="lev-progress-bar">
          <div id="progress-fill" class="progress-fill"></div>
        </div>
        ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
        <div class="lev-row-container instruction-small">
            <p>${t[(0, helpers_1.camelize)(prompt)]}</p>
        </div>
      </div>`;
        },
        response_ends_trial: false,
        prompt_above_buttons: promptAboveButtons,
        button_choices: () => {
            const stim = (0, taskStore_1.taskStore)().nextStimulus;
            const itemLayoutConfig = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stim.itemId];
            return itemLayoutConfig.response.values;
        },
        button_html: () => {
            const stim = (0, taskStore_1.taskStore)().nextStimulus;
            const itemLayoutConfig = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stim.itemId];
            return `<button 
                  class='${itemLayoutConfig.classOverrides.buttonClassList.join(' ')}' 
                  ${stim.assessmentStage === 'test_response' ? 'disabled' : ''}>
                  %choice%
                </button>`;
        },
        on_load: async () => {
            var _a;
            startTime = performance.now();
            const stim = (0, taskStore_1.taskStore)().nextStimulus;
            const itemLayoutConfig = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stim.itemId];
            const playAudioOnLoad = itemLayoutConfig === null || itemLayoutConfig === void 0 ? void 0 : itemLayoutConfig.playAudioOnLoad;
            const pageStateHandler = new helpers_1.PageStateHandler(stim.audioFile, playAudioOnLoad);
            const buttonClass = itemLayoutConfig.classOverrides.buttonClassList[0];
            const responseButtonChildren = document.querySelectorAll(`button.${buttonClass}`);
            const buttonContainer = document.getElementById('jspsych-html-multi-response-btngroup');
            // update progress bar
            const progress = ((0, taskStore_1.taskStore)().testTrialCount / (0, taskStore_1.taskStore)().totalTrials) * 100;
            (0, updateProgressBar_1.updateProgressBar)(progress);
            (0, helpers_1.equalizeButtonSizes)(responseButtonChildren);
            // Setup Sentry Context
            (0, helpers_1.setSentryContext)({
                itemId: stim.itemId,
                taskName: stim.task,
                pageContext: 'stimulus',
            });
            // set up replay button
            (0, helpers_1.setupReplayAudio)(pageStateHandler);
            (0, helpers_1.addExperimenterButtons)();
            (0, helpers_1.setupFullscreenButton)();
            // enable response buttons immediately after prompt audio finishes so stagger effect can be interrupted
            const audioConfig = {
                restrictRepetition: {
                    enabled: false,
                    maxRepetitions: 2,
                },
                onEnded: () => {
                    responseButtonChildren.forEach((button) => {
                        button.disabled = false;
                    });
                },
            };
            // play trial audio
            helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio[(0, helpers_1.camelize)(stim.audioFile)], audioConfig);
            responseButtonChildren.forEach((button) => {
                button.addEventListener('click', (event) => {
                    var _a;
                    const okButton = document.querySelector('.primary');
                    if (!okButton) {
                        const okButton = document.createElement('button');
                        okButton.className = 'primary';
                        okButton.textContent = 'OK';
                        okButton.style.marginTop = '16px';
                        okButton.addEventListener('click', () => {
                            taskSetup_1.jsPsych.finishTrial();
                        });
                        (_a = buttonContainer.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(okButton, buttonContainer.nextSibling);
                    }
                    responseButtonChildren.forEach((button) => {
                        setTimeout(() => {
                            button.disabled = false;
                        }, 10);
                        button.classList.remove('success-shadow');
                    });
                    event.target.classList.add('success-shadow');
                    selectedButtonIndex = Array.prototype.indexOf.call(responseButtonChildren, event.target);
                });
            });
            if (itemLayoutConfig.isStaggered) {
                // Handle the staggered buttons
                let audioKeys = [
                    'child-survey-response1',
                    'child-survey-response2',
                    'child-survey-response3',
                    'child-survey-response4',
                ];
                await (0, helpers_1.handleStaggeredButtons)(pageStateHandler, buttonContainer, audioKeys, stim.itemId, stim.assessmentStage === 'instructions');
                // disable demo buttons
                if (stim.assessmentStage === 'instructions') {
                    responseButtonChildren.forEach((button) => {
                        button.disabled = true;
                    });
                    // Add primary OK button under the other buttons
                    const okButton = document.createElement('button');
                    okButton.className = 'primary';
                    okButton.textContent = 'OK';
                    okButton.style.marginTop = '16px';
                    okButton.addEventListener('click', () => {
                        taskSetup_1.jsPsych.finishTrial();
                    });
                    (_a = buttonContainer.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(okButton, buttonContainer.nextSibling);
                }
            }
            // update the trial number
            taskStore_1.taskStore.transact('trialNumSubtask', (oldVal) => oldVal + 1);
        },
        on_finish: (data) => {
            (0, staggerButtons_1.disableStagger)();
            helpers_1.PageAudioHandler.stopAndDisconnectNode();
            let responseValue = null;
            let responseIndex = null;
            const t = (0, taskStore_1.taskStore)().translations;
            const corpus = (0, taskStore_1.taskStore)().corpus;
            const stim = (0, taskStore_1.taskStore)().nextStimulus;
            const itemLayoutConfig = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stim.itemId];
            if (stim.trialType !== 'instructions') {
                if (itemLayoutConfig) {
                    const { response } = itemLayoutConfig;
                    if (!response) {
                        throw new Error('Choices not defined in the config');
                    }
                    responseIndex = data.button_response;
                    responseValue = response.values[responseIndex];
                }
                taskSetup_1.jsPsych.data.addDataToLastTrial({
                    // specific to this trial
                    item: stim.item,
                    distractors: stim.distractors,
                    corpusTrialType: stim.trialType,
                    responseLocation: selectedButtonIndex,
                    itemUid: stim.itemUid,
                    audioFile: stim.audioFile,
                    corpus: corpus,
                    audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
                    correct: false, // false because there is no correct answer
                    answer: stim.distractors[selectedButtonIndex],
                });
                // corpusId and itemId fields are used by ROAR but not ROAD
                if ((0, taskStore_1.taskStore)().storeItemId) {
                    taskSetup_1.jsPsych.data.addDataToLastTrial({
                        corpusId: (0, taskStore_1.taskStore)().corpusId,
                        itemId: stim.itemId,
                    });
                }
            }
            else {
                taskSetup_1.jsPsych.data.addDataToLastTrial({
                    // false because it's not a real trial
                    correct: false,
                });
            }
            if (stim.assessmentStage === 'test_response') {
                taskStore_1.taskStore.transact('testTrialCount', (oldVal) => oldVal + 1);
            }
        },
    };
};
exports.surveyItem = surveyItem;
